import FlowConfigBase from '#client/config/FlowConfigBase';
import PAGES, { PAGE_KEYS } from '#client/config/flowPageConfig';
import AUTH_POLICY from '#client/constants/authPolicy';
import * as ROUTES from '#client/constants/routes';

export default FlowConfigBase.createEntry({
  id: 's-corp',
  pageKeys: [
    PAGE_KEYS.QUALIFICATION,
    PAGE_KEYS.BUSINESS_INFO,
    PAGE_KEYS.CONTACT_INFO,
    PAGE_KEYS.BUSINESS_EXPERIENCE,
    PAGE_KEYS.BUSINESS_STAGE,
    PAGE_KEYS.INDUSTRY,
    PAGE_KEYS.REGISTERED_AGENT,
    PAGE_KEYS.PACKAGE_SELECTION,
    PAGE_KEYS.WFC,
    PAGE_KEYS.EIN,
    PAGE_KEYS.OPERATING_AGREEMENT,
    PAGE_KEYS.MONEY_PRO,
    PAGE_KEYS.RUSH_FILING,
    PAGE_KEYS.CHECKOUT
  ],
  pageConfigs: {
    [PAGES.BUSINESS_INFO.pageComponent]: {
      pageComponentProps: {
        formationCountyStates: new Set(['NY'])
      }
    },
    [PAGES.PACKAGE_SELECTION.pageComponent]: {
      pageComponentProps: {
        baselineProducts: ['s_corp_designation']
      }
    },
    [PAGES.WFC.pageComponent]: {
      pageComponentProps: {
        couponCode: '199_off_first_year'
      }
    }
  },
  autoLoadBusiness: false,
  authRedirect: null,
  authPolicy: AUTH_POLICY.NOT_ENFORCED,
  disableCartCreation: false,
  entityType: 'llc',
  hasFormation: true,
  isPrimary: true,
  isSCorp: true,
  postOrderAutoLogin: true,
  postOrderRedirect: ROUTES.SHOP_SCORP_ADDONS,
  priceListUuids: {
    development: '2485c5df-45e7-43e4-a414-6edbc677d643',
    production: '280d59c9-2b27-4fd6-bca0-e004349a0068'
  },
  version: 1
});
